import React from 'react';
import { Modal } from "antd";
import { ReactComponent as CloseSVG } from "../../../../img/default-svg/close-black.svg";
import '../../../Webhooks/WebhooksWrapper/style.scss';
import '../../../../layout/Modal.scss';
import Button from "../../../Button";
import { identity} from "../../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const MultisendFeeModal = ({ open, close, submit }) => {
  const handleSubmit = () => {
    submit();
    close();
  }

  const { t } = useTranslation();

  return (
    <Modal
      width={450}
      title={t('text.multisend')}
      visible={open}
      onCancel={close}
      footer={null}
      className={`webhook-modal webhook-modal-${identity}`}
      centered
      closeIcon={<CloseSVG />}
      destroyOnClose
      maskClosable={false}
    >
      <div className="webhook-modal">
        {t('admin.estimate_miner_fee')}

        <div className="webhook-modal__fee">
          <Button type="secondary" onClick={close}>{t('admin.get_back')}</Button>
          <Button type="primary" onClick={handleSubmit}>{t('admin.continue')}</Button>
        </div>
      </div>
    </Modal>
)
};

export default MultisendFeeModal;